module.exports = __webpack_public_path__ + "img/swap.23125e63.svg";